import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import { useGetAssetCategoriesQuery } from '@/store/services'
import Select from 'react-select'
import { SelectWrapper } from '../wrapper'

export const AssetCategorySelector = ({ value, onChange, includeAll = true, className = '' }) => {
  const { data: { asset_categories: categories = [] } = {}, isLoading } = useGetAssetCategoriesQuery()
  const [selected, setSelected] = useState(null)

  const options = useMemo(() => ([
    ...(includeAll ? [{ value: null, label: 'Todas' }] : []),
    ...categories.map((c) => ({ value: c.id, label: c.name }))
  ]), [categories, includeAll])

  useEffect(() => {
    const next = options.find((opt) => opt.value === value) || (includeAll ? options[0] : null)
    setSelected(next)
  }, [value, options, includeAll])

  const handleChange = (opt) => {
    setSelected(opt)
    onChange?.(opt ? opt.value : null)
  }

  return (
    <div className={className}>
      <SelectWrapper label='Categoría'>
        {(styles) => (
          <Select
            isClearable={!includeAll}
            isSearchable
            isLoading={isLoading}
            options={options}
            value={selected}
            placeholder='Selecciona'
            onChange={handleChange}
            styles={styles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
          />
        )}
      </SelectWrapper>
    </div>
  )
}

AssetCategorySelector.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  includeAll: PropTypes.bool,
  className: PropTypes.string
}
